import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function getSecuritySettings(securitySettingsId: number) {
    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/dealerships/security-settings/${securitySettingsId}/`,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get security settings: ${axiosError.message}`,
            axiosError,
            { securitySettingsId },
        )

        throw new Error(axiosError.message)
    }
}
